import Stats from 'lib/stats.module';
import { gsap } from 'gsap';
import config from 'config';
import Stage from './modules/levels/stage';
import assets from './assets';
import { Application, Container, Graphics, InteractionManager } from 'pixi.js';
import tools from 'tools';
export default class App extends Container {
  constructor() {
    super();
    tools.autobind(this);
    this.delta = 1;
    this.stats = null;
    this.stage = null;
  }
  init() {
    // document.backgroundColor = "#ffffff";

    document.body.style.margin = 0;
    document.body.style.display = "block";
    // document.body.style["background-color"] = "#fff";
    document.body.style.color = "#fff";
    document.body.style.overflow = "hidden";
    this.view = document.createElement("canvas");
    this.view.style.width = "100%";
    this.view.style.height = "100%";
    this.view.style.position = "absolute";
    this.view.style.top = "0px";
    this.view.style.left = "0px";
    document.body.appendChild(this.view);
    this.initEngine();
    this.initEvents();
    this.onResize();
    config.debug && this.debug();
    assets.init();
    assets.on("onProgress", this.onLoadingProgress);
    assets.on("ready", this.onReady);
  }
  onLoadingProgress(event) {
    let percent = parseInt(event.progress * 100);
    this.loadingProgressCB && this.loadingProgressCB(percent);
  }
  initEngine() {
    this.app = new Application({
      view: this.view,
      width: 1,
      height: 1,
      backgroundColor: 0xffffff,
      //backgroundAlpha: 0,
      resolution: window.devicePixelRatio,
      autoDensity: true,
      antialias: true,
      resizeTo: window
    });
    config.interactionManager = new InteractionManager(this.app.renderer);
    config.renderer = this.app.renderer;

    // this.mouse = this.app.renderer.plugins.interaction.mouse.global;
    this.stage = this.app.stage;
    config.background = this.background = new Graphics();
    this.background.beginFill(0xfff000, 0);
    this.background.drawRect(0, 0, 1, 1);
    this.background.endFill();
    this.stage.addChild(this.background);

    //START ENGINE
    gsap.ticker.add(this.update);
    gsap.ticker.fps(config.fps);

    // TRACE  DEBUG ///////////////////////
    // const style = new TextStyle({
    //   fontFamily: 'voodoo_casual',
    //   fontSize: 16,
    //   fill: '#ff0000',
    //   wordWrap: true,
    //   wordWrapWidth: 500
    // });

    // this.texte = new Text("Debug\n", style);

    // this.stage.addChild(this.texte);

    // setInterval(() => {
    //   this.stage.addChild(this.texte);
    // }, 1000);
  }
  trace(msg) {

    // this.texte.text += msg + "\n";
  }
  initEvents() {
    this.view.addEventListener('touchstart', this.onDown, false);
    this.view.addEventListener('touchend', this.onUp, false);
    this.view.addEventListener('touchmove', this.onMove, false);
    this.view.addEventListener('mouseup', this.onUp, false);
    this.view.addEventListener('mouseleave', this.onUp, false);
    this.view.addEventListener('mousedown', this.onDown, false);
    this.view.addEventListener('mousemove', this.onMove, false);
    this.view.addEventListener('wheel', this.onWheel);
    window.addEventListener('resize', this.onResize, false);
    window.addEventListener("orientationchange", this.onResize, false);
  }
  onDown(event) {
    event.preventDefault();
    this.setMouse(event);
    config.app.emit("onDown");
    // Unlock audio on user gesture (required for iOS).
    if (!config._audioUnlocked && config.handlePageFocus) {
      config.handlePageFocus();
    }
    if (config.sound) {
      !this.clicked && config.sound.play();
      this.clicked = true;
    }
  }
  onUp(event) {
    config.isDown = false;
    config.app.emit("onUp");
  }
  onMove(event) {
    this.setMouse(event);
  }
  onWheel(event) {
    config.app.emit("onWheel", event);
  }
  setMouse(event) {
    if (event.touches) {
      config.mouse.x = event.touches[0].clientX;
      config.mouse.y = event.touches[0].clientY;
    } else {
      config.mouse.x = event.clientX;
      config.mouse.y = event.clientY;
    }
  }
  onResize(size) {
    let __width = size && size.width ? size.width : window.innerWidth;
    let __height = size && size.height ? size.height : window.innerHeight;
    this.background.scale.set(__width, __height);
    this.level && this.level.onResize(__width, __height);

    //Force iOS view resize 
    setTimeout(() => {
      window.scrollTo(0, 1);
      config.ActiveReseize = true;
    }, 500);
  }
  onReady() {
    this.onReadyCB && this.onReadyCB();
  }
  startGame(callback) {
    config.firstTime = true;
    gsap.delayedCall(.05, () => {
      config.level = this.level = new Stage();
      this.stage.addChild(this.level);
      this.onResize();
      callback && callback();
    });
  }
  debug() {
    //DEBUG

    this.stats = new Stats();
    document.body.appendChild(this.stats.dom);
  }

  //Destroy and reset current level

  dispose() {
    this.level && this.level.dispose();
  }
  pause(val) {
    this._pause = val;
    config.pause = val;
    if (config.youtubePlayables) {
      val ? config.youtubePlayables.pausePlaytime() : config.youtubePlayables.resumePlaytime();
    }
    if (val) {
      this.app.stop();
    } else {
      this.app.start();
    }
  }
  update(a, b, c, time) {
    if (config.pause) {
      return;
    }
    this.delta = b / (1 / config.fps) / 1000;
    this.level && this.level.update(this.delta);

    //Debug
    this.stats && this.stats.update();
    //
  }

  //FBInstant interface

  startLoading() {
    assets.load();
  }
  loadinProgress(callback) {
    this.loadingProgressCB = callback;
  }
  onGameReady(callback) {
    this.onReadyCB = callback;
  }
}
